import { Button } from '@src/common/components/button/Button';
import { css } from '@src/common/styles/Styles';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick?: () => void;
  disabled?: boolean;
};

export const CancelButton = ({ onClick, disabled }: Props) => {
  const { t } = useTranslation();
  return (
    <Button
      className={cancelButton}
      disabled={disabled}
      variant="outlined"
      onClick={onClick}
    >
      {t('cancel')}
    </Button>
  );
};

const cancelButton = css({
  borderRadius: '100px',
});
